import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './RequestModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import requestImg from '../../assets/images/request-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import saveImg from '../../assets/images/save-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';

class RequestModal extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraClass = null,
    extraAction = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      extraAction: extraAction,
      touched: false,
      errorMessage: null,
      loading: false
    });
  }

  updateLoading = (attr, loading) => {
    const updatedCarriers = { ...this.state.requestForm };
    updatedCarriers[attr].loading = loading;
    this.setState({ cardForm: updatedCarriers });
  }

  compareDisplayValue = (a, b) => {
    if (a.displayValue > b.displayValue) {
      return 1;
    } else if (a.displayValue < b.displayValue) {
      return -1;
    }
    return 0;
  }

  createLocations() {
    let formattedLocations = [];
    const locations = Object.values(this.props.locations);
    locations.sort(function (a, b) {
      if (a.originatingLocation && !b.originatingLocation) {
        return -1;
      } else if (!a.originatingLocation && b.originatingLocation) {
        return 1;
      } else if (a.region > b.region) {
        return 1;
      } else if (a.region === b.region) {
        return a.locationName > b.locationName ? 1 : -1;
      } else {
        return -1;
      }
    });
    locations.forEach(function (obj) {
      formattedLocations.push({ value: obj.locationName, displayValue: obj.locationName })
    });
    return formattedLocations;
  }

  state = {
    localCard: null,
    loading: false,
    showHistory: false,
    history: null,
    historyLoading: false,
    requestForm: {
      origin: this.createInputConfig(
        'select',
        {
          options: [...this.createLocations()],
          animate: 0
        },
        'Звідки: ',
        'Балахна',
        {},
        true,
        classes.InlineInput),
      destination: this.createInputConfig(
        'select',
        {
          options: [...this.createLocations()],
          animate: 0
        },
        'Куди: ',
        'Баловка',
        { required: true },
        true,
        classes.InlineInput),
      manager: this.createInputConfig(
        'input-search',
        {
          options: [],
          animate: 0
        },
        'Менеджер: ',
        null,
        { required: true },
        true,
        null,
        (ev) => this.createManagers(ev)),
      priority: this.createInputConfig(
        'select',
        {
          options: [
            { value: 'П1', displayValue: 'П1' },
            { value: 'П2', displayValue: 'П2' },
            { value: 'П3', displayValue: 'П3' }
          ],
          animate: 0
        },
        'Пріоритет: ',
        'П3',
        { required: true },
        true),
      requestType: this.createInputConfig(
        'select',
        {
          options: [
            { value: 'ЗК', displayValue: 'ЗК' },
            { value: 'ЗПМ', displayValue: 'ЗПМ' },
            { value: 'ЗПМ_ЗК', displayValue: 'ЗПМ_ЗК' }
          ],
          animate: 0
        },
        'Тип Заявки: ',
        'ЗК',
        { required: true },
        true),
      weight: this.createInputConfig(
        'input',
        { type: 'number', step: "0.01", min: "0", placeholder: "0", animate: 0 },
        'Вага (тонн): ',
        0.1,
        { required: true },
        true,
        classes.InlineTriple),
      partialLoad: this.createInputConfig(
        'toggle-switch',
        { animate: 0 },
        'Часткове Завантаження: ',
        false,
        { required: true },
        true,
        classes.InlineTriple),
      initiator: this.createInputConfig(
        'toggle-switch',
        { animate: 0 },
        'Ініціатор: ',
        false,
        { required: true },
        true,
        classes.InlineTriple),
      requestTripDate: this.createInputConfig(
        'input',
        { type: 'date', animate: 0 },
        'Дата: ',
        '',
        { required: true, type: 'date' },
        true,
        classes.InlineInput),
      dateFlexibility: this.createInputConfig(
        'select',
        {
          options: [
            { value: '0', displayValue: '0' },
            { value: '1', displayValue: '+1' },
            { value: '2', displayValue: '+2' },
            { value: '3', displayValue: '+3' },
            { value: '4', displayValue: '+4' },
            { value: '5', displayValue: '+5' },
            { value: '6', displayValue: '+6' },
            { value: '7', displayValue: '+7' }
          ],
          animate: 0
        },
        'Гнучкість Дати: ',
        '0',
        { required: true },
        true,
        classes.InlineInput),
      unloading: this.createInputConfig(
        'input',
        { type: 'text', animate: 0 },
        'Вивантаження: ',
        '',
        { required: false },
        true),
      moneyRequests: this.createInputConfig(
        'money-requests',
        {
          labelClass: classes.InlineLabel,
          animate: 0
        },
        'Заявки з Money: ',
        '',
        { required: false },
        true,
        null,
        { calculateWeight: (ev) => this.calculateWeight(ev) })
    }
  }

  roundNum(num) {
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
  }

  calculateWeight = (ev) => {
    ev.preventDefault();
    const updatedRequests = this.state.requestForm;
    updatedRequests.weight.value = this.roundNum(updatedRequests.moneyRequests.value.reduce((a, b) => a + (b.weight || 0), 0));
    this.setState({ requestForm: updatedRequests });
    this.updateCard();
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.closeCard();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.card && nextProps.card) {
      const updatedCardForm = { ...this.state.requestForm };
      const updateFields = Object.keys(this.state.requestForm);
      updateFields.forEach(field => {
        if (this.props.card[field] && this.props.card[field] !== nextProps.card[field]) {
          updatedCardForm[field].value = nextProps.card[field];
          updatedCardForm[field].elementConfig.animate = updatedCardForm[field].elementConfig.animate + 1;
          if (field === "manager") {
            if (this.state.requestForm.manager.elementConfig.options.length <= 2) {
              this.getManager(nextProps.card[field]);
            }
          } else if (field === "requestTripDate") {
            updatedCardForm[field].value = this.formatDate(nextProps.card[field]);
          }
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.localCard === null && this.props.card != undefined) {
      const updatedCardForm = { ...this.state.requestForm };
      updatedCardForm.requestTripDate.value = this.formatDate(this.props.card.requestTripDate);
      updatedCardForm.origin.value = this.props.card.origin;
      updatedCardForm.destination.value = this.props.card.destination;
      updatedCardForm.origin.elementConfig.options = [...this.createLocations()];
      updatedCardForm.destination.elementConfig.options = [...this.createLocations()];
      updatedCardForm.priority.value = this.props.card.priority;
      updatedCardForm.requestType.value = this.props.card.requestType;
      updatedCardForm.weight.value = this.props.card.weight;
      updatedCardForm.partialLoad.value = this.props.card.partialLoad;
      updatedCardForm.dateFlexibility.value = this.props.card.dateFlexibility;
      updatedCardForm.unloading.value = this.props.card.unloading;
      updatedCardForm.initiator.value = this.props.card.initiator;
      if (this.props.card.manager && updatedCardForm.manager.elementConfig.options.length <= 2) {
        this.getManager(this.props.card.manager);
      } else {
        updatedCardForm.manager.elementConfig.options = this.parseManagers().sort(this.compareDisplayValue);
        updatedCardForm.manager.value = this.props.card.manager;
      }
      updatedCardForm.unloading.value = this.props.card.unloading;
      updatedCardForm.moneyRequests.value = this.props.card.moneyRequests;
      this.setState({ localCard: { ...this.props.card }, requestForm: updatedCardForm });
    }

    if (prevProps.locations !== this.props.locations) {
      const updatedCardForm = { ...this.state.requestForm };
      updatedCardForm.origin.elementConfig.options = [...this.createLocations()];
      updatedCardForm.destination.elementConfig.options = [...this.createLocations()];
      this.setState({ requestForm: updatedCardForm });
    }

    if (this.props.card === null && this.state.localCard !== null) {
      this.setState({ localCard: null });
    }

    if (this.props.managers !== prevProps.managers) {
      const cardForm = { ...this.state.requestForm };
      cardForm.manager.elementConfig.options = this.props.managers.map(manager => ({ value: manager.name, displayValue: manager.name })).sort(this.compareDisplayValue);
      this.setState({ requestForm: cardForm });
    }
  }

  getManager(manager) {
    const updatedForm = { ...this.state.requestForm };
    updatedForm.manager.elementConfig = { options: [{ value: manager, displayValue: manager }] };
    updatedForm.manager.value = manager;
    this.setState({ requestForm: updatedForm });
  }

  parseManagers() {
    return this.props.managers.map((manager, index) => {
      return (
        { value: manager.name, displayValue: manager.name }
      )
    });
  }

  createManagers() {
    if (this.state.requestForm.loading) {
      return this.props.managers;
    }

    this.updateLoading("manager", true);
    axios({
      method: 'get',
      url: '/api/v1/managers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.updateLoading("manager", false);
        const cardForm = { ...this.state.requestForm };
        this.props.onSetManagers(response.data);
      })
      .catch(error => {
        this.updateLoading("manager", false);
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/managers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  formatDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(0, 10);
  }

  transformDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(6, 10) + "-" + date.substring(3, 5) + "-" + date.substring(0, 2);
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = (value ? value.trim !== '' : false) && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type == 'confirmPassword') {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && (value ? value.trim === '' : true)) {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть пошту';
      }
    }

    if (rules.type == 'confirmPassword' && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.requestForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedOrderForm[elementId] = updatedFormElement;
    let capacityFilled = null;
    if (elementId === "managers") {
      capacityFilled = updatedOrderForm.managers.value.reduce((sum, manager) => parseInt(sum) + (parseInt(manager.load) || 0), 0);
      updatedOrderForm.capacityFilled.value = capacityFilled;
    }

    const updatedCard = { ...this.state.localCard };
    updatedCard[elementId] = event.target.value;
    if (elementId === "managers") {
      updatedCard.capacityFilled = capacityFilled;
    }
    this.setState({ requestForm: updatedOrderForm, localCard: updatedCard });
  }

  removeElementHandler = (element, arrayProperty, property) => {
    const updatedCard = { ...this.state.localCard };
    let foundIndex = -1;
    for (let i = 0; i < updatedCard[arrayProperty].length; i++) {
      if (updatedCard[arrayProperty][i][property] === element) {
        foundIndex = i;
      }
    }
    updatedCard[arrayProperty].splice(foundIndex, 1);
    this.setState({ localCard: updatedCard });
  }

  updateCard = () => {
    const request = {
      id: parseInt(this.props.card.id.toString().substring(1, this.props.card.id.toString().length)),
      manager: this.state.requestForm.manager.value,
      requestTripDate: this.state.requestForm.requestTripDate.value + "T00:00:00",
      origin: {
        ...this.props.locations[this.state.requestForm.origin.value]
      },
      destination: {
        ...this.props.locations[this.state.requestForm.destination.value]
      },
      priority: this.state.requestForm.priority.value,
      requestType: this.state.requestForm.requestType.value,
      weight: parseFloat(this.state.requestForm.weight.value),
      partialLoad: this.state.requestForm.partialLoad.value,
      dateFlexibility: this.state.requestForm.dateFlexibility.value,
      unloading: this.state.requestForm.unloading.value,
      initiator: this.state.requestForm.initiator.value,
      tripId: this.props.card.tripId,
      moneyRequests: this.props.card.moneyRequests,
      sorting: this.props.card.sorting,
    }

    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/requests/update',
      data: request,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ loading: false });
        this.props.addNotification("Заявка успішно збережена.", "Success");
        this.onRequestUpdateHandler(response.data);
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response && error.response.status === 401) {
          this.getCarriers();
        } else if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests/update'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  onRequestUpdateHandler(request) {
    const updatedRequests = [...this.props.requests];
    let index = -1;
    for (let i = 0; i < updatedRequests.length; i++) {
      if (parseInt(updatedRequests[i].id) === parseInt(request.id)) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      updatedRequests[index] = request;
      console.log("Updated requets:");
      console.log(updatedRequests);
      this.props.onSetRequests(updatedRequests);
    } else {
      console.log("Something went wrong. Invalid index for request update.");
    }
  }

  deleteCard = () => {
    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/requests/delete?id=' + this.props.card.id.substring(1, this.props.card.id.length),
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.addNotification("Заявка була успішно видалена.", "Success");
        this.setState({ loading: false });
        this.onCardDeleteHandler(this.props.card.id.substring(1, this.props.card.id.length));
        this.props.closeCard();
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/requests/delete?id=' + this.props.card.id.substring(1, this.props.card.id.length)
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  onCardDeleteHandler(cardId) {
    const updatedRequests = [...this.props.requests];
    let index = -1;
    cardId = parseInt(cardId);
    console.log("Card id " + cardId);
    for (let i = 0; i < updatedRequests.length; i++) {
      if (updatedRequests[i].id === cardId) {
        index = i;
        break;
      }
    }
    if (index !== -1) {
      updatedRequests.splice(index, 1);
      this.props.onSetRequests(updatedRequests);
      console.log("Updated requests");
    }
  }

  openHistory = (event) => {
    event.preventDefault();
    this.setState({ showHistory: true, historyLoading: true });
    axios({
      method: 'get',
      url: '/api/v1/request/history?id=' + this.props.card.id.substring(1, this.props.card.length),
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ historyLoading: false, history: response.data });
      })
      .catch(error => {
        console.log(error);
        this.setState({ historyLoading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/request/history?id=' + this.props.card.id.substring(1, this.props.card.length)
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  parseHistoryDate = (historyDate) => {
    return historyDate.substring(8, 10) + "/" + historyDate.substring(5, 7) + " " + historyDate.substring(11, 16);
  }

  parseHistoryChange = (hist) => {
    let historyChange = this.parseHistoryDate(hist.changeDate) + " - ";
    historyChange += hist.changeMessage;
    return historyChange;
  }

  getId(id) {
    id = parseInt(id.toString().substring(1, id.length));
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  render() {
    let show = true;
    let card = null;

    if (this.state.localCard === null) {
      card = null;
      show = false;
    } else {

      const requestFormArray = [];
      for (let key in this.state.requestForm) {
        requestFormArray.push({ id: key, config: this.state.requestForm[key] });
      }

      let loading = null;
      if (this.state.loading) {
        loading = (
          <Spinner />
        )
      }

      let history = null;
      if (this.state.history) {
        history = (
          <ul className={classes.HistoryList}>
            {
              this.state.history.map((hist) => {
                return (
                  <li className={classes.HistoryEntry}>
                    {this.parseHistoryChange(hist)}
                  </li>
                )
              })
            }
          </ul>
        );
      }

      let headerClasses = [classes.Header];
      headerClasses.push(classes.HeaderWhite);

      card = (
        <Aux>
          <Modal
            loading={this.state.historyLoading}
            show={this.state.showHistory}
            modalClosed={() => this.setState({ showHistory: false })} >
            <div className={classes.HistoryHolder}>

              {history}

              <div className={classes.HistoryFooter}>
                <Button
                  btnType={['Success', 'NoMargin']}
                  clicked={() => this.setState({ showHistory: false })}>
                  ЗАКРИТИ
                </Button>
              </div>
            </div>
          </Modal>
          <div className={headerClasses.join(' ')}>

            <div className={classes.TripTitle}>
              <Icon iconClass={classes.CarIcon} iconSource={requestImg} iconAlt='' className={classes.CardIcon} />
              <p>{this.props.card ? this.getId(this.props.card.id) : null}.&nbsp;</p>
              <p>{this.state.localCard.origin}</p>
              <Icon iconClass={classes.ArrowIcon} iconSource={arrowImg} iconAlt='' className={classes.CardIcon} />
              <p>{this.state.localCard.destination}</p>
            </div>

            <button className={classes.CloseButton} onClick={this.props.closeCard}>
              <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
            </button>
            <p style={{ height: "100%" }}></p>
          </div>

          <div className={classes.Body} >
            {loading}
            {requestFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  loading={formElement.config.loading}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}

          </div>

          {loading}

          <div className={classes.Footer}>

            <div className={classes.FooterButtons}>
              <ButtonIcon
                btnType='Success'
                clicked={this.updateCard}
                disabled={this.state.loading}
                iconClass={classes.ButtonIcon}
                iconSource={saveImg}
                iconAlt=''>ЗБЕРЕГТИ</ButtonIcon>
              <ButtonIcon
                btnType='Success'
                disabled={this.state.loading}
                iconClass={classes.ButtonIcon}
                iconSource={historyImg}
                clicked={(ev) => this.openHistory(ev)}
                iconAlt=''>ІСТОРІЯ</ButtonIcon>
              <ButtonIconConfirm
                btnType='Danger'
                disabled={this.state.loading}
                iconClass={classes.ButtonIcon}
                iconSource={deleteImg}
                iconAlt=''
                clicked={this.deleteCard}
                confirmText='видалити Заявку'>ВИДАЛИТИ</ButtonIconConfirm>
            </div>
          </div>
        </Aux>
      );
    }

    return (
      <Aux>
        <Backdrop show={show} clicked={this.props.closeCard} />
        <div
          className={classes.CardModal}
          style={{
            transform: show ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: show ? '1' : '0'
          }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    managers: state.managers,
    requests: state.requests,
    locations: state.locations,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetRequests: (requests) => dispatch({
      type: actionTypes.REQUESTS,
      requests: requests
    }),
    onSetManagers: (managers) => dispatch({
      type: actionTypes.SET_MANAGERS,
      managers: managers
    }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestModal);



// WEBPACK FOOTER //
// ./src/components/RequestModal/RequestModal.js